module.exports = __webpack_public_path__ + "static/media/arrow-to-bottom.3f752556.svg";